import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Header from '../../common/Header';
import Footer from '../../common/Footer';
import SubscriptionBox from './SubscriptionBox';
import { Context } from '../../../App';
import polarBlack from '../../../assets/polarBrand/logotype_black.svg';
import polarWhite from '../../../assets/polarBrand/logotype_white.svg';
import Switch from '@mui/material/Switch';
import SeoHelmet from '../../common/SeoHelmet';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import MuiSnackbar from '../../common/MuiSnackbar';

const Pricing = () => {
  const { theme } = useContext(Context);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isCheckoutInProgress, setIsCheckoutInProgress] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [activePlanName, setActivePlanName] = useState('');
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const getAllSubscriptions = async () => {
      setLoading(true);
      try {
        const response = await axios({
          method: 'GET',
          url: '/api/v1/users/getAllSubscriptions',
        });
        setSubscriptions(response.data.subscriptions);
      } catch (err) {
        /* console.log(err); */
      }
      setLoading(false);
    };
    getAllSubscriptions();
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('polarCheckoutSuccess')) {
      sessionStorage.removeItem('polarCheckoutSuccess');
      setSuccessOpen(true);
    }
  }, []);

  const showCheckoutError = (message) => {
    setErrorMessage(message);
    setErrorOpen(true);
  };

  return (
    <>
      <SeoHelmet
        title="GeoCalc | Pricing"
        description="Choose a GeoCalc plan. Monthly and yearly subscriptions with secure checkout."
        url="https://www.geocalc.app/pricing"
        image="https://www.geocalc.app/assets/og-theory-v1.jpg" // replace with a real asset or remove
        breadcrumbs={[
          { name: 'Home', url: 'https://www.geocalc.app/' },
          { name: 'Pricing', url: 'https://www.geocalc.app/pricing' },
        ]}
      />

      <Header />
      <MuiSnackbar open={errorOpen} setOpen={setErrorOpen} severity="error" alertMessage={errorMessage} />
      <div className={`${loading ? 'verticallyAlignParent' : 'pricing'}`}>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <Dialog open={successOpen} onClose={() => setSuccessOpen(false)} maxWidth="xs" fullWidth>
              <DialogTitle>Subscription updated</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Your subscription was updated successfully. You can now continue using your new plan.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setSuccessOpen(false)} variant="contained">
                  Done
                </Button>
              </DialogActions>
            </Dialog>
            <div className="pricingSwitch">
              <div className={`pricingSwitchLeft ${!checked && 'pricingSwitchChecked'}`}>Monthly</div>
              <div className="pricingSwitchMiddle">
                <Switch
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                  sx={{
                    '& .MuiSwitch-switchBase': {
                      color: '#1976d2', // thumb color (off state)
                    },
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#1976d2', // thumb color (on state)
                    },
                    '& .MuiSwitch-switchBase + .MuiSwitch-track': {
                      backgroundColor: '#1976d2', // track color (off state)
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#1976d2', // track color (on state)
                    },
                  }}
                />
              </div>
              <div className={`pricingSwitchRight ${checked && 'pricingSwitchChecked'}`}>Yearly</div>
            </div>
            <div className="pricingContainer">
              {subscriptions.map((subscription) => {
                return (
                  <SubscriptionBox
                    subscription={subscription}
                    key={subscription.name}
                    checked={checked}
                    isCheckoutInProgress={isCheckoutInProgress}
                    setIsCheckoutInProgress={setIsCheckoutInProgress}
                    activePlanName={activePlanName}
                    setActivePlanName={setActivePlanName}
                    onCheckoutSuccess={() => setSuccessOpen(true)}
                    onCheckoutError={showCheckoutError}
                  />
                );
              })}
            </div>
            <div className="paymentPoweredBy">
              <p>Payments securely powered by</p>
              {theme === 'light' ? (
                <img src={polarBlack} alt="Description" width="60" />
              ) : (
                <img src={polarWhite} alt="Description" width="60" />
              )}
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Pricing;
